import React, { PropsWithChildren } from "react";
import { SnackbarProvider } from "notistack";
import { AlertSnackbar } from "./AlertSnackbar";

export const CustomSnackbarProvider = ({
  children,
}: PropsWithChildren): React.ReactElement<PropsWithChildren> => {
  return (
    <SnackbarProvider
      Components={{
        success: AlertSnackbar,
        error: AlertSnackbar,
        warning: AlertSnackbar,
        info: AlertSnackbar,
      }}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={5000}
      maxSnack={5}
    >
      {children}
    </SnackbarProvider>
  );
};
